import NextLink from "next/link";
import { useState } from "react";
// import ConfirmDialog from "@/src/components/confirm-dialog";
import ConfirmDialog from "@/src/lib/ui/confirmDialog";
import UploadPriscriptionForm from "./uploadPriscriptionForm";
import Iconify from "@/src/components/iconify/Iconify";
import IconCode from "@/src/lib/iconCode";
import useBreakpoint from "@/src/lib/util/custom-hooks/useBreakPoint";
import Link from "next/link";

const StaticBlock = () => {
    const [open, setOpen] = useState(false);
    const isMobile = useBreakpoint("sm");

    const openUplodHandler = () => {
        setOpen(true);
    };

    const handleCloseUploadPopup = () => {
        setOpen(false);
    };

    return (
        <>
            <div className="md:py-8 py-3 max-w-6xl mx-auto md:px-0 px-4">
                <h3 className="md:text-2xl text-xl text-black font-bold md:mb-6 mb-5 md:text-left text-center">
                    Explore More
                </h3>

                <div className="grid md:gap-6 sm:gap-3 gap-2 md:grid-cols-4 sm:grid-cols-2 grid-cols-1 pb-2">
                    <Link
                        className="cursor-pointer font-bold relative flex w-full h-full flex-col md:h-20 h-auto pt-4 pb-4 pr-4 pl-4 border border-primary border-solid rounded-md group hover:bg-primary hover:scale-110 transition-transform duration-300 ease-in-out"
                        href="/find-a-test?allowHc=0"
                    >
                        <div className="flex flex-row items-center gap-3">
                            <div>
                                <Iconify
                                    icon={IconCode.searchMedical}
                                    width={40}
                                    className="text-primary group-hover:text-white"
                                />
                            </div>

                            <div>
                                <h4 className="md:text-lg text-base text-black font-bold group-hover:text-white">
                                    Find a Test
                                </h4>
                                <p className="text-black md:text-sm text-xs whitespace-nowrap group-hover:text-white font-normal">
                                    View Tests and Prices
                                </p>
                            </div>
                        </div>
                    </Link>
                    {isMobile && (
                        <div
                            className="cursor-pointer font-bold relative flex w-full h-full flex-col pt-4 pb-4 pr-4 pl-4 border border-primary border-solid rounded-md group hover:bg-primary hover:scale-110 transition-transform duration-300 ease-in-out"
                            onClick={openUplodHandler}
                        >
                            <div className="flex flex-row items-center gap-3">
                                <div>
                                    <Iconify
                                        icon={IconCode.doctorPrescription}
                                        width={40}
                                        className="text-primary group-hover:text-white"
                                    />
                                </div>

                                <div>
                                    <h4 className="md:text-lg text-base text-black font-bold group-hover:text-white">
                                        Unsure About Tests?
                                    </h4>
                                    <p className="text-black md:text-sm text-xs whitespace-nowrap group-hover:text-white font-normal">
                                        Upload Doctor's Prescription & Get
                                        Callback
                                    </p>
                                </div>
                            </div>
                        </div>
                    )}
                    <Link
                        className="cursor-pointer font-bold relative flex w-full h-full flex-col pt-4 pb-4 pr-4 pl-4 border border-primary border-solid rounded-md group hover:bg-primary hover:scale-110 transition-transform duration-300 ease-in-out"
                        href="/find-a-test?allowHc=1"
                    >
                        <div
                            className="flex flex-row items-center gap-3"
                            // onClick={openUplodHandler}
                        >
                            <div>
                                <Iconify
                                    icon={IconCode.home}
                                    width={40}
                                    className="text-primary group-hover:text-white"
                                />
                            </div>

                            <div>
                                <h4 className="md:text-lg text-base text-black font-bold group-hover:text-white">
                                    Home Collection
                                    {/* Upload Prescription */}
                                </h4>
                                <p className="text-black md:text-sm text-xs whitespace-nowrap group-hover:text-white font-normal">
                                    Book Home Collection
                                </p>
                            </div>
                        </div>
                    </Link>
                    <Link
                        className="cursor-pointer font-bold relative flex w-full h-full flex-col pt-4 pb-4 pr-4 pl-4 border border-primary border-solid rounded-md group hover:bg-primary hover:scale-110 transition-transform duration-300 ease-in-out"
                        href="/locate-us"
                    >
                        <div className="flex flex-row items-center gap-3">
                            <div>
                                <Iconify
                                    icon={IconCode.healthiconsHospital}
                                    width={40}
                                    className="text-primary group-hover:text-white"
                                />
                            </div>

                            <div>
                                <h4 className="md:text-lg text-base text-black font-bold group-hover:text-white">
                                    Locate Centres
                                </h4>
                                <p className="text-black md:text-sm text-xs whitespace-nowrap group-hover:text-white font-normal">
                                    Find Centres near you
                                </p>
                            </div>
                        </div>
                    </Link>

                    <Link
                        className="cursor-pointer font-bold relative flex w-full h-full flex-col pt-4 pb-4 pr-4 pl-4 border border-primary border-solid rounded-md group hover:bg-primary hover:scale-110 transition-transform duration-300 ease-in-out"
                        href="/health-packages"
                    >
                        <div className="flex flex-row items-center gap-3">
                            <div>
                                <Iconify
                                    icon={IconCode.healthPackage}
                                    width={40}
                                    className="text-primary group-hover:text-white"
                                />
                            </div>

                            <div>
                                <h4 className="md:text-lg text-base text-black font-bold group-hover:text-white">
                                    Health Packages
                                </h4>
                                <p className="text-black md:text-sm text-xs whitespace-nowrap group-hover:text-white font-normal">
                                    Whole Body Health Checkup
                                </p>
                            </div>
                        </div>
                    </Link>
                </div>
            </div>
            <ConfirmDialog
                open={open}
                onClose={handleCloseUploadPopup}
                title={
                    <h4 className="text-xl font-bold">Upload Prescription</h4>
                }
                content={
                    <UploadPriscriptionForm
                        handleClose={handleCloseUploadPopup}
                    />
                }
                maxWidth="xs"
                isCancel={true}
            />
        </>
    );
};
export default StaticBlock;
